import { format } from 'date-fns';
import Button from '../../../../../common/Button/Button';
import style from './TransferSuccessfulModal.module.scss';
import Modal from '../../../../../common/Modals/Modal/Modal';
import { KycApproveIcon } from '../../../../../../assets/icons/svgicons';

const TransferSuccessfulModal = ({ show, handleClose, topUpData, previousModalClose }) => {
    const listtransfer = [
        { label: 'Source Wallet', subvalue: topUpData?.cryptoAsset ? topUpData?.cryptoAsset : "--", },
        { label: "Transaction ID", subvalue: topUpData?.id ? `${String(topUpData.id).slice(0, 4)}....${String(topUpData.id).slice(-4)}` : "--", },
        { label: 'Date & Time', subvalue: topUpData.created_at ? format(new Date(topUpData.created_at), "dd MMM, yyyy hh:mm a") : "--" },
    ];
    return (
        <>
            <Modal
                show={show}
                handleClose={handleClose}
                className={style.transferSuccessModal}
            >
                <div className={style.transferSuccessModal_innerSec}>
                    <div className={style.transferIcon}>
                        <KycApproveIcon />
                    </div>
                    <div className={style.transferHead}>
                        <h2 className='smallText'>Transfer Successful!</h2>
                        <h1 className='smallText'>+$<span>{topUpData?.amountDeposited || '--'}</span></h1>
                        <p>has been added to your card.</p>
                    </div>
                    <ul className={style.transferList}>
                        {listtransfer.map((items, index) => (
                            <li key={index}>
                                <label>{items.label}</label>
                                <p className={items.className}>{items.subvalue}</p>
                            </li>
                        ))}
                    </ul>
                    <Button className={style.btn_size} fluid onClick={() => {
                        handleClose()
                        previousModalClose()
                    }}>
                        Done
                    </Button>
                </div>
            </Modal>
        </>
    )
}

export default TransferSuccessfulModal